import React from 'react'
import { connect } from 'react-redux'
import '../css/styles.css';

class NegativeImportantInfo extends React.Component {

    render() {
        return (
            <div>
                <p><b><u>{this.props.strings.IMPORTANT_NEGATIVE_MESSAGE}</u></b></p>
                <p>
                    <b>{this.props.strings.NEGATIVE_INFO_TEXT_1}</b>
                </p>
                <p>{this.props.strings.NEGATIVE_INFO_TEXT_2}</p>
                <p>
                    {this.props.strings.NEGATIVE_INFO_TEXT_3}
                    <a className="dont-break-out" href={this.props.strings.NEGATIVE_FACT_SHEET} target="_blank">{this.props.strings.NEGATIVE_FACT_SHEET}</a>
                </p>
                <p>{this.props.strings.NEGATIVE_INFO_TEXT_4}</p>
                <p>
                    {this.props.strings.NEGATIVE_INFO_TEXT_5}
                    <a className="dont-break-out" href={this.props.strings.COVID_TREATMENT_URL} target="_blank">{this.props.strings.COVID_TREATMENT_URL}</a>
                    {this.props.strings.NEGATIVE_INFO_TEXT_5_1}
                </p>
                <p><u>{this.props.strings.NEGATIVE_INFO_TEXT_6}</u></p>
                <p>{this.props.strings.NEGATIVE_INFO_TEXT_7}</p>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        strings: state.language.strings,
    }
}

const ConnectedNegativeImportantInfo = connect(
    mapStateToProps
)(NegativeImportantInfo);
export default ConnectedNegativeImportantInfo;
